import { z } from "@/utils/form";

/**
 * URL-facing auth channel: `email` vs `phone` (SMS OTP via Edge).
 * Legacy `sms` is accepted and normalised to `phone`.
 */
export const authMethodSearchSchema = z
    .enum(["email", "phone", "sms"])
    .optional()
    .transform((m) => (m === undefined ? undefined : m === "sms" ? ("phone" as const) : m));

export type AuthMethodSearch = z.infer<typeof authMethodSearchSchema>;

/** Prefer `method`; fall back to legacy `contactMethod` (email | phone). */
export function resolveContactMethodFromAuthSearch(params: {
    method?: AuthMethodSearch;
    contactMethod?: "email" | "phone";
}): "email" | "phone" | undefined {
    if (params.method === "phone") return "phone";
    if (params.method === "email") return "email";
    return params.contactMethod;
}

export function contactMethodToMethodParam(contactMethod: "email" | "phone"): "email" | "phone" {
    return contactMethod === "phone" ? "phone" : "email";
}
